import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { Fade } from '@mui/material';
import { $toastData, hideToast } from '../model';
import * as Styled from './styled';

let timeout: NodeJS.Timeout;

export const Toast = () => {
  const [toastData] = useUnit([$toastData]);

  const autoCloseToast = () => {
    if (timeout) clearTimeout(timeout);
    if (!toastData) return;
    if (!toastData?.autoHideTimerMs) return;

    timeout = setTimeout(hideToast, toastData.autoHideTimerMs);
  };

  useEffect(() => {
    autoCloseToast();
  }, [toastData]);

  return (
    <Fade in={toastData?.visible}>
      <Styled.Alert
        severity={toastData?.type ?? 'error'}
        variant="filled"
        onClose={() => hideToast()}
      >
        {toastData?.text}
      </Styled.Alert>
    </Fade>
  );
};
